import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root'
})
export class BancosServices {

  dataUrl = Config.URL_BASE;

  constructor(
    private http: HttpClient
  ) { }

  catalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/bancos/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  post(dto: Bancos): Observable<any> {
    let url_ = this.dataUrl + '/bancos/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/bancos/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: Bancos): Observable<any> {
    let url_ = this.dataUrl + '/bancos/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getBanco(id: number): Observable<any> {
    let url_ = this.dataUrl + '/bancos/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getSatBancos(titulo: String): Observable<any> {
    let url_ = '';
    if (titulo !== '') {
      url_ = this.dataUrl + '/bancos/get/satbanco/' + titulo;
    } else {
      url_ = this.dataUrl + '/bancos/get/satbanco/0';
    }
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

}

export class Bancos {
  id: number;
  banco: number;
  titulo: String;
  rfc: String;
  clave: String;
  descripcion: String;
  tipo: String;
  gralUsrCrea: number;
  gralUsrBaja: number;
  gralUsrActualiza: number;
  gral_emp_id: number;
  gral_suc_id: number;
  banc: String;
}

export class SatBanco {
  id: number;
  clav: String;
  nombre: String;
  razon_social: String;
}

export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}
